function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.6666 2.79746C19.9308 3.12412 19.14 3.34412 18.31 3.44329C19.1575 2.93579 19.8083 2.13162 20.1141 1.17329C19.3216 1.64329 18.4433 1.98496 17.5083 2.16912C16.7608 1.37162 15.6933 0.873291 14.5133 0.873291C11.8641 0.873291 9.91746 3.34496 10.5158 5.91079C7.10663 5.73996 4.08329 4.10662 2.05913 1.62412C0.984126 3.46829 1.50163 5.88079 3.32829 7.10246C2.65663 7.08079 2.02329 6.89662 1.47079 6.58912C1.42579 8.48996 2.78829 10.2683 4.76163 10.6641C4.18413 10.8208 3.55163 10.8575 2.90829 10.7341C3.42996 12.3641 4.94496 13.55 6.74163 13.5833C5.01663 14.9358 2.84329 15.54 0.666626 15.2833C2.48246 16.4475 4.63996 17.1266 6.95663 17.1266C14.575 17.1266 18.8791 10.6925 18.6191 4.92162C19.4208 4.34246 20.1166 3.61996 20.6666 2.79746Z",
  fill: "white"
});

function SvgTwitterWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterWhite);
export default __webpack_public_path__ + "static/media/twitter-white.42949ee3.svg";
export { ForwardRef as ReactComponent };